<template>
    <div>        
        <confirm ref="confirm"></confirm>
        <list v-bind:refresh="this.refresh" v-bind:refreshSubList="this.refreshChild" table='pzndetails' :label="$t('pzn details')" v-on:childMessage="onMessageFromListReceived" v-on:sublistMessage="onMessageFromSubListReceived" initialSortBy="pzn" :initialSortDesc="false" :subListDefinition="subListDefinition"></list>
        <v-dialog v-bind:value="showFileDialog" v-bind:persistent="true" max-width="600">
            <v-card>
                <v-card-title>
                    {{$t("upload file")}}
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon dense right color="primary" v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
                        </template>
                        <span v-if="type=='ASIN'">{{$t("import ASIN")}}</span>
                        <span v-else-if="type=='ZALANDO'">{{$t("import ZALANDO")}}</span>
                        <span v-else-if="type=='DOUGLAS'">{{$t("import DOUGLAS")}}</span>
                        <span v-else-if="type=='IDEALO'">{{$t("import IDEALO")}}</span>
                        <span v-else>{{$t("import pzndetails")}}</span>
                    </v-tooltip>
                </v-card-title>
                <v-card-text>
                    <v-file-input show-size v-model=file :label="$t('select file')"/>
                    <v-select v-model="folder" label="Typ" :items=getFolders()></v-select>
                    <v-checkbox v-model="overwrite" :label="$t('overwrite file')"></v-checkbox>
                    <v-chip outlined color="primary" v-if='this.text!=""'>
                        {{text}}
                    </v-chip>
                </v-card-text>
                <v-card-actions>
                    <v-btn elevation="20" class="white--text" color="#49a5ac" @click=submitFile><v-icon dense left>mdi-cloud-upload-outline</v-icon>{{$t("upload")}}</v-btn>
                    <v-btn elevation="20" class="white--text" color="#49a5ac" @click=cancel()><v-icon dense left>mdi-cancel</v-icon>{{$t("cancel")}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-bind:value="showDialog" v-bind:persistent="true" max-width="600">
            <v-card>
                <v-card-title>
                    {{title}}
                </v-card-title>
                <v-card-text>
                    <div v-for="field in fields" v-bind:key="field.value">
                        <div v-if="field.value !== 'id' && field.value !== 'actions' && field.value !== 'manually' && field.value !== 'parentID'">
                            <v-select v-if="field.value == 'country'" v-model="field.model" v-bind:label="field.text" :items=getCountries() item-text="value" item-value="code"></v-select>
                            <v-text-field v-else-if="field.value != 'customer'" v-model="field.model" v-bind:label="field.text"/>
                        </div>
                    </div>
                    <v-chip outlined color="primary" v-if='this.text!=""'>
                        {{text}}
                    </v-chip>
                </v-card-text>
                <v-card-actions>
                    <v-btn elevation="20" class="white--text" color="#49a5ac" @click=save()><v-icon dense left>mdi-content-save-outline</v-icon>{{$t("save")}}</v-btn>
                    <v-btn elevation="20" class="white--text" color="#49a5ac" @click=cancel()><v-icon dense left>mdi-cancel</v-icon>{{$t("cancel")}}</v-btn>
                    <v-btn elevation="20" class="white--text" color="#49a5ac" @click=uploadFile()><v-icon dense left>mdi-file-upload-outline</v-icon>{{$t("upload file")}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import List from "@/components/List";
import Api from "@/Api";
import { Utils } from "@/Utils";
import Confirm from "@/components/Confirm";


export default {    
    components:
    {
        List, Confirm
    },

    data()
    {
        return {
            showDialog: "",
            showFileDialog: "",
            file: null,
            refresh: 0,
            refreshChild: 0,
            text: "",
            fields: [],
            title: "",
            folder: "Allgemein",
            overwrite: false,
            pznID: -1,
            type: "PZN",
            subListDefinition:
            [
                {label: this.$t("asin"), table:"asins", initialSortBy:"asin", initialSortDesc:false, type: "ASIN"},
                {label: this.$t("zalando"), table:"zalandoitems", initialSortBy:"item", initialSortDesc:false, type: "ZALANDO"},
                {label: this.$t("douglas"), table:"douglasitems", initialSortBy:"item", initialSortDesc:false, type: "DOUGLAS"},
                {label: this.$t("idealo"), table:"idealoitems", initialSortBy:"item", initialSortDesc:false, type: "IDEALO"}
            ]
        };
    },

    props: [],

    mixins: [Utils],

    methods:
    {
        onMessageFromListReceived (message)
        {
            this.text = "";
            if (message.cmd === "searchExecuted")
            {
                this.pznID = -1;
            }
            else if (message.cmd === "recordSelected")
            {                
                this.pznID = message.item.id;                
            } 
            else if (message.cmd === "newRecord")
            {
                this.type = "PZN"
                this.title = this.$t("new pzndetails");
                this.fields = JSON.parse(JSON.stringify(message.header));
                this.fields.shift(); //remove ID

                for (let field of this.fields)
                {
                    field.model = "";
                }
                this.showDialog = true;
            }
            else if (message.cmd === "updRecord")
            {
                this.type = "PZN"
                this.title = this.$t("update pzndetails");
                this.fields = JSON.parse(JSON.stringify(message.header));

                for (let field of this.fields)
                {
                    field.model = message.item[field.value]
                }
                this.showDialog = true;
            }
            else if (message.cmd === "delRecord")
            {
                const id = message.item["id"];
                const self = this;
                Api.deleteRecord("pzndetails", id).then(function(result)
                {
                    if (result.status === 200)
                    {
                        self.refresh += 1;
                    }
                    else
                        alert (self.$t("action not possible"));

                })
                .catch((e) =>
                {
                    alert (self.$t("action not possible"));
                });
            }
        },
        onMessageFromSubListReceived (message)
        {
            this.text = "";
            if (message.cmd === "newRecord")
            {
                this.title = this.$t("new "+message.type);
                this.type = message.type;
                this.fields = JSON.parse(JSON.stringify(message.header));
                this.fields.shift(); //remove ID

                for (let field of this.fields)
                {                    
                    field.model = "";
                }
                this.showDialog = true;
            }
            else if (message.cmd === "updRecord")
            {
                this.title = this.$t("update "+message.type);
                this.type = message.type;
                this.fields = JSON.parse(JSON.stringify(message.header));

                for (let field of this.fields)
                {                    
                    field.model = message.item[field.value]
                }
                this.showDialog = true;
            }
            else if (message.cmd === "delRecord")
            {
                const id = message.item["id"];
                const self = this;
                Api.deleteRecord(message.type === "ASIN" ? "asins" : message.type === "ZALANDO" ? "zalandoitems" : message.type === "IDEALO" ? "idealoitems" : "douglasitems", id).then(function(result)
                {
                    if (result.status === 200)
                    {
                        self.refreshChild += 1;
                    }
                    else
                        alert (self.$t("action not possible"));
                })
                .catch((e) =>
                {
                    alert (self.$t("action not possible"));
                });
            }
        },
        cancel ()
        {
            this.showFileDialog = "";
            this.showDialog = "";
            this.fields = [];
            this.text = "";
            this.file = null;
            this.refresh++;
        },
        save ()
        {
            const self = this;
            this.text = "";
            for (let field of this.fields)
            {
                if (field.text === "PZN")
                    if (field.model.trim() == "")
                    {
                        this.text = this.$t("enter pzn");
                        return;
                    }
                    else
                        break;
            }

            if (this.type == "ASIN" || this.type == "ZALANDO" || this.type == "DOUGLAS" || this.type == "IDEALO")
            {
                let parentFound = false;
                for (let field of this.fields)
                {                    
                    if (field.text === "parentID")
                    {
                        field.model = this.pznID;                    
                        parentFound = true;
                        break;
                    }
                }
                if (!parentFound)
                    this.fields.push({model:this.pznID, text:"parentID", value:"parentID"});
            }

            const table = (this.type === "ASIN" ? "asins" : this.type === "ZALANDO" ? "zalandoitems" : this.type === "IDEALO" ? "idealoitems" : this.type === "DOUGLAS" ? "douglasitems" : "pzndetails")

            Api.saveRecord(table, this.fields).then(function(result)
            {
                if (result.status === 200)
                {
                    self.showDialog = "";
                    if (table == "asins" || table == "zalandoitems" || table == "douglasitems" || table == "idealoitems")
                        self.refreshChild++;
                    else
                        self.refresh++;
                }
                else
                    self.text = self.$t("action not possible");
            })
            .catch((e) =>
            {
                if (e.response.status === 409)
                    self.text = self.$t("already exists");
                else
                    self.text = self.$t("action not possible");
            });
        },
        uploadFile ()
        {
            this.cancel();
            this.showFileDialog = true;
        },
        submitFile()
        {
            if (!this.file)
            {
                this.text = this.$t("select file");
                return;
            }
            const self = this;
            this.text = "";
            const doctype = (this.type === "ASIN" ? "ASINS" : this.type === "ZALANDO" ? "ZALANDOITEMS" : this.type === "DOUGLAS" ? "DOUGLASITEMS" : this.type === "IDEALO" ? "idealoitems" : "PZNDETAILS")            
            let formData = new FormData();
            formData.append('file', this.file);            
            formData.append('type', doctype);            
            formData.append('folder', this.folder);
            formData.append('overwrite', this.overwrite);
            if (this.isAdmin())
                formData.append('customerId', "intern")

            Api.uploadFile(formData)
            .then(function(e)
            {
                if (e.data.result == "processed")
                {
                    self.$refs.confirm.open(self.$t("file processed"), {confirm:false}).then((confirm) =>
                    {
                        self.cancel();
                        if (doctype == "PZNDETAILS")
                            self.refresh++;
                        else
                            self.refreshChild++;
                    });
                }
                else if (e.data.result == "error")
                    self.text = self.$t("processing not possible");
                    if (e.data.details)
                        self.text += " " + e.data.details;
                else
                    self.cancel();
            })
            .catch(function(e)
            {
                if (e.response.status === 409)
                    self.text = self.$t("already exists");
                else
                    self.text = self.$t("action not possible");
            });
        }
    }
};
</script>